// src/components/UserManagement/CreateRole.jsx
import React, { useState } from 'react';
import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Typography,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { createRole } from '../../../store/userManagement/userManagementThunks';
import { useTranslation } from 'react-i18next';
import * as Icons from '@mui/icons-material';

// ✅ Safe icons compatible with legacy Material Icons font
const materialIcons = [
  "Person",
  "Group",
  "SupervisorAccount",
  "Security",
  "Lock",
  "VpnKey",
  "AssignmentInd",
  "Badge",
  "Settings",
  "Work",
  "Engineering",
  "SupportAgent",
  "School",
  "LocalPolice",
  "VerifiedUser",
  "HowToReg",
  "Search",
  "ManageSearch",
  "Psychology",
  "Business",
  "People",
  "AccountCircle",
  "AccountBox",
  "RecentActors",
  "Contacts",
  "ContactPage",
  "Rule",
  "Policy",
  "Task",
  "Checklist",
  "FactCheck",
  "TrackChanges",
  "Tune",
  "SettingsSuggest",
  "SettingsApplications",
].sort();





export default function CreateRole(onClose) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [name, setName] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState(materialIcons[0] || '');

  const handleSubmit = () => {
    if (!name.trim() || !title.trim() || !icon) {
      return;
    }

    dispatch(
      createRole({body: {
        name: name.trim(),
        title: title.trim(),
        description: description.trim(),
        icon,
      }})
    );
};

  return (
    <Box>
      <DialogTitle>{t("create_role_form_header")}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, py: 1 }}>
          {/* Name */}
          <TextField
            label={t("create_role_form_name_label")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            required
          />

          {/* Title */}
          <TextField
            label={t("create_role_form_title_label")}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            required
          />

          {/* Description */}
          <TextField
            label={t("create_role_form_description_label")}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            multiline
            rows={3}
            fullWidth
          />

          {/* ✅ Icon Selector — Pure dropdown with icons only */}
          <FormControl fullWidth>
            <InputLabel>{t("create_role_form_icon_label")}</InputLabel>
            <Select
              value={icon}
              onChange={(e) => setIcon(e.target.value)}
              label={t("create_role_form_icon_label")}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {Icons[selected] ? React.createElement(Icons[selected], { style: { marginRight: 8 } }) : null}
                </Box>
              )}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                    '& .MuiMenuItem-root': {
                      minHeight: 48,
                      gap: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    },
                  },
                },
              }}
            >
              {materialIcons.map((iconName) => (
                <MenuItem key={iconName} value={iconName}>
                  {Icons[iconName] ? React.createElement(Icons[iconName], { style: { marginRight: 8 } }) : null}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose()}
          color="secondary"
        >
          {t("cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          sx={{
            background: 'var(--peoplmap-primary)',
            '&:hover': { background: '#53c03d' },
          }}
        >
          {t("create")}
        </Button>
      </DialogActions>
    </Box>
  );
}